module.exports = __webpack_public_path__ + "static/day00-1e4c576f1c79d678ffd02900dfdf97bd.png";